import { NgModule } from '@angular/core';
import { AuthGuard } from './auth.guard.service';
import { RestService } from './rest.service';
import { TokenTimer } from './token.timer';
import { FileUploadService } from './upload.service';
import { ClientDownloadService } from './client-download.service';

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
        AuthGuard,
        RestService,
        TokenTimer,
        FileUploadService,
        ClientDownloadService
    ],
})
export class ServiceModule {
}
